import React from 'react';
import noop from "mn-utils/noop";

import Button from "../../../../../dumb/Button/M";

import openPopupPwdReset from "../../utils/openPopupPwdReset";
import openPopupForcedSignOut from "./utils/openPopupForcedSignOut";
import SecondaryDataDisplay from "./SecondaryDataDisplay";
import PrimaryDataDisplay from "./PrimaryDataDisplay";
import MethodsDisplay from "./MethodsDisplay";

module.exports = (props) => {
  const data = props.userData || {};
  const reloadPageData = props.reloadPageData || noop;
  return (
    <>
      <PrimaryDataDisplay data={data} />
      <div className="h1 bgDADCE1 mt45 mb45"/>
      <SecondaryDataDisplay data={data}/>
      <div className="h1 bgDADCE1 mt45 mb45"/>
      <MethodsDisplay data={data} update={reloadPageData} />
      <div className="mt45 layoutRow mh-15 mb64 (w268|ph15)>1">
        <div>
          <Button
            onClick={() => openPopupPwdReset(data, reloadPageData)}
            disabled={data.must_change_password}
          >
            Reset Password
          </Button>
        </div>
        <div>
          <Button onClick={() => openPopupForcedSignOut(data, reloadPageData)}>
            Sign out user
          </Button>
        </div>
      </div>
    </>
  )
}
